import React from "react";
import { useSelector } from "react-redux";

const RiskInformation = ({ details }) => {
  // const { single_policy_cover } = useSelector((state) => state.policy);
  const { all_covers } = useSelector((state) => state.cover);

  return (
    <div className='table-responsive-sm'>
      <table className='table table-centered table-striped nowrap w-100 no-footer'>
        <thead>
          <tr>
            <th
              className='sorting'
              tabIndex='0'
              rowSpan='1'
              colSpan='1'
              style={{ width: "130.8px" }}
              aria-label='Customer: activate to sort column ascending'
            >
              Policy Cover Type
            </th>
            <th
              className='sorting'
              tabIndex='0'
              rowSpan='1'
              colSpan='1'
              style={{ width: "140.8px" }}
              aria-label='Customer: activate to sort column ascending'
            >
              Cover For
            </th>
            <th
              className='sorting'
              tabIndex='0'
              rowSpan='1'
              colSpan='1'
              style={{ width: "108.8px" }}
              aria-label='Phone: activate to sort column ascending'
            >
              Rate(%)
            </th>
            <th
              className='sorting'
              tabIndex='0'
              rowSpan='1'
              colSpan='1'
              style={{ width: "147.8px" }}
            >
              Sum Insured (&#8358;)
            </th>
            <th
              className='sorting'
              tabIndex='0'
              rowSpan='1'
              colSpan='1'
              style={{ width: "147.8px" }}
              aria-label='Email: activate to sort column ascending'
            >
              Annual Premium (&#8358;)
            </th>
            <th
              className='sorting'
              tabIndex='0'
              rowSpan='1'
              colSpan='1'
              style={{ width: "246.8px" }}
              aria-label='Location: activate to sort column ascending'
            >
              Detail Description / Specification
            </th>
          </tr>
        </thead>

        <tbody>
          {details?.map((item, i) => (
            <tr>
              <td>
                {
                  all_covers?.unpaginated_cover?.filter(
                    (cover) =>
                      String(cover.id) === String(item?.policyCoverType)
                  )[0].name
                }
              </td>
              <td>{item?.coverFor}</td>
              <td>{item?.rate}</td>
              <td>{item?.sumInsured}</td>
              <td>{item?.annualPremium}</td>
              <td>{item?.description}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RiskInformation;
